import { pick } from 'lodash'

const syncSourceMap = {
  0: 'その他',
  1: '他社取り込み',
  3: 'ビートレンド',
  4: 'Safie社',
  5: 'レスラク',
}

export default syncSourceMap

// 他社取り込み
export const isOtherSource = pick(syncSourceMap, [1])

// レスラク
export const isResrakuSource = pick(syncSourceMap, [5])
